/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiFlexGroup, EuiFlexItem, EuiTitle } from '@elastic/eui'

import type { AnyCluster } from '@modules/ccm-lib/types'
import { FormattedMessage } from '@modules/i18n'

import ServiceList from './ServiceList'

import type { FC } from 'react'

type Props = {
  ccmCluster: AnyCluster
}

const CCMClusterServices: FC<Props> = ({ ccmCluster }) => (
  <EuiFlexGroup direction='column' gutterSize='m'>
    <EuiFlexItem>
      <EuiTitle size='s'>
        <h3>
          <FormattedMessage id='ccm.cluster-services.title' defaultMessage='Services' />
        </h3>
      </EuiTitle>
    </EuiFlexItem>
    <EuiFlexItem>
      <ServiceList ccmCluster={ccmCluster} />
    </EuiFlexItem>
  </EuiFlexGroup>
)

export default CCMClusterServices
